import { takeLatest, call, put, select } from 'redux-saga/effects'
import { CREATE_TRIP_ACTIVITY, GET_TRIPS, UPDATE_TRIP_ACTIVITY } from './actionTypes'
import { setLoader } from '../loader/actions'
import tripService from '../../supabaseServices/TripService'
import LocationService from '../../supabaseServices/LocationService'
import { setTrips } from './actions'
import { makeSelectUser } from '../auth/selectors'
import { push } from 'connected-react-router'
import activityService from '../../supabaseServices/ActivityService'
import { setTripActivities } from './actionsTripActivity'
import { setSnackbar } from '../snackbar/actions'

export function* createTripActivitySaga(payload) {
  try {
    yield put(setLoader(true))
    const user = yield select(makeSelectUser())
    const location_uuid = yield call(LocationService.createLocation, {
      ...payload.data.location,
      created_by: user.uuid,
    })
    const insertData = {
      ...payload.data,
      created_by: user.uuid,
      location_uuid,
      location: payload.data.location.address,
    }
    yield put(setLoader(true))
    yield call(activityService.createActivity, insertData)

    const tripUuid = payload.data.trip_uuid
    const updatedTrips = yield call(tripService.getPaginatedTrips, 1)
    yield put(setTrips(updatedTrips))
    const updatedActivities = yield call(tripService.getActivitiesByTripUUID, tripUuid)
    yield put(setTripActivities(updatedActivities))

    yield put(push(`/trips/${tripUuid}`))
  } catch (error) {
    console.error(error)
    yield put(
      setSnackbar({
        open: true,
        severity: 'error',
        message: `${error.message ? error.message : 'Error creating trip activity'}`,
      }),
    )
  } finally {
    yield put(setLoader(false))
  }
}

export function* updateTripActivitySaga(payload) {
  try {
    yield put(setLoader(true))
    const user = yield select(makeSelectUser())
    const { id, ...updateData } = payload.data
    const updatePayload = { ...updateData, created_by: user.uuid }
    let location_uuid, locationAddress

    if (payload.data.location) {
      if (typeof payload.data.location === 'object') {
        location_uuid = yield call(LocationService.createLocation, {
          ...payload.data.location,
          created_by: user.uuid,
        })
        const locationData = yield call(LocationService.getLocationByUUID, location_uuid)
        locationAddress =
          locationData && locationData.length > 0
            ? locationData[0].address
            : payload.data.location.address
      } else if (typeof payload.data.location === 'string' && payload.data.location_uuid) {
        const locationData = yield call(
          LocationService.getLocationByUUID,
          payload.data.location_uuid,
        )
        locationAddress =
          locationData && locationData.length > 0 ? locationData[0].address : payload.data.location
        location_uuid = payload.data.location_uuid
      }
      updatePayload.location = locationAddress
      updatePayload.location_uuid = location_uuid
    }

    yield call(activityService.updateActivity, id, updatePayload)

    const tripUuid = payload.data.trip_uuid
    const updatedActivities = yield call(tripService.getActivitiesByTripUUID, tripUuid)
    yield put(setTripActivities(updatedActivities))
    const updatedTrips = yield call(tripService.getPaginatedTrips, 1)
    yield put(setTrips(updatedTrips))

    yield put(push(`/trips/${tripUuid}`))
  } catch (error) {
    console.error(error)
    yield put(
      setSnackbar({
        open: true,
        message: error.message ? error.message : 'Error updating trip activity',
        severity: 'error',
      }),
    )
  } finally {
    yield put(setLoader(false))
  }
}

export function* getTripsSagaFn() {
  try {
    yield put(setLoader(true))
    const res = yield call(tripService.getPaginatedTrips, 1)
    yield put(setTrips(res))
  } catch (error) {
    console.error(error)
    yield put(
      setSnackbar({
        open: true,
        message: `${error.message ? error.message : 'Error fetching trip activity'}`,
        severity: 'error',
      }),
    )
  } finally {
    yield put(setLoader(false))
  }
}

export default function* tripSaga() {
  yield takeLatest(GET_TRIPS, getTripsSagaFn)
  yield takeLatest(CREATE_TRIP_ACTIVITY, createTripActivitySaga)
  yield takeLatest(UPDATE_TRIP_ACTIVITY, updateTripActivitySaga)
}
